import { dfpEnv } from './dfp-env';
const getAdvertById = (id) => dfpEnv.adverts.get(id) ?? null;
export { getAdvertById };
